import toastr from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { useParams } from 'react-router-dom';
import { fetchWrapper } from 'utils/fetchWrapper';
import type {
  PromptFunctionsResponse,
  PromptFunctionsAttributes,
} from 'types/PromptFunctions';

type mutationVariables = Partial<PromptFunctionsAttributes>;

export function useUpdatePromptFunctions(
  functionID: string | null | undefined
) {
  const queryClient = useQueryClient();
  const sparkID = useParams()?.id;

  const updatePromptFunctions = (attributes: mutationVariables) => {
    if (!functionID) {
      Promise.reject('Prompt Functions ID can not be null');
    }

    const body = {
      data: {
        id: functionID,
        type: 'promptFunctions',
        attributes: {
          ...attributes,
          outputBoardNodeTypeID:
            attributes.outputBoardNodeTypeID === 'other' ||
            !attributes.outputBoardNodeTypeID
              ? null
              : +attributes.outputBoardNodeTypeID,
        },
      },
    };

    return fetchWrapper<PromptFunctionsResponse>({
      url: `/PromptFunctions/${functionID}`,
      method: 'PATCH',
      body: body,
    });
  };

  return useMutation('promptFunctions', updatePromptFunctions, {
    onSuccess: () => {
      queryClient.invalidateQueries(['promptFunctions', functionID]);
      queryClient.invalidateQueries(['sparkDiagnostics', sparkID]);
      queryClient.invalidateQueries(['sparkStep']);
      queryClient.invalidateQueries(['AIModelExecutionParameters']);
      toastr.success('Prompt saved');
    },
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`failed to update Prompt Functions: ${error.message}`);
      }
    },
  });
}
